import axios from "axios";
import { securityStoreModule } from "./modules/security/store-index";
import { employeesStoreModule } from "./store/employees";
import { institutionStoreModule } from "./store/institutions";
import { absencesStoreModule } from "./store/absences";
import { employmentsStoreModule } from "./store/employments";
import { dutiesStoreModule } from "./store/duties";
import { eventsStoreModule } from "./store/events";
import { poolStoreModule } from "./store/pools";
import { supervisionTimeScheduleStoreModule } from "./store/supervisionTimeSchedules";
import { positionsStoreModule } from "./store/positions";
import { normPeriodStoreModule } from "./store/normPeriods";
import { holidayStoreModule } from "./store/holiday";
import { salaryStoreModule } from "./store/salaries";
import { departmentsStoreModule } from "./store/departments";
import { employmentStatementsStoreModule } from "./store/employmentStatements";
import { cypressStoreModule } from "./store/cypress";
import * as plugins from "./store/plugins";
import { infoCenterStoreModule } from "./store/infoCenter";
import { absenceRequestsStoreModule } from "./store/absenceRequests";
//Vue.config.devtools = true;
//Vue.use(Vuex);

export interface IMainConfigImport {
  environmentName: string;
  keyCloakClientId: string;
  keyCloakUrl: string;
  keyCloakRealm: string;
  insightsInstrumentationKey: string;
  insightsRoleName: string;
  i18NLocale: string;
  i18NFallbackLocale: string;
  urlToHelp: string;
}

export interface IMainConfig {
  ENVIRONMENTNAME: string;
  KEYCLOAK_CLIENTID: string;
  KEYCLOAK_URL: string;
  KEYCLOAK_REALM: string;
  I18N_LOCALE: string;
  I18N_FALLBACK_LOCALE: string;
  APP_API_URL: string;
  urlToHelp: string;
}

const mainConfig: IMainConfig = {
  ENVIRONMENTNAME: "",
  KEYCLOAK_CLIENTID: "",
  KEYCLOAK_URL: "",
  KEYCLOAK_REALM: "",
  I18N_LOCALE: "",
  I18N_FALLBACK_LOCALE: "",
  APP_API_URL: "",
  urlToHelp: ""
};

export interface IAuthRoot {
  mainConfig: IMainConfig;
}

import { createStore, Store, useStore as baseUseStore } from "vuex";
import { InjectionKey } from "vue";

export const key: InjectionKey<Store<IMainConfig>> = Symbol();

export default createStore({
  modules: {
    security: securityStoreModule,
    employees: employeesStoreModule,
    institutions: institutionStoreModule,
    absences: absencesStoreModule,
    employments: employmentsStoreModule,
    duties: dutiesStoreModule,
    events: eventsStoreModule,
    holidays: holidayStoreModule,
    pools: poolStoreModule,
    supervisionTimeSchedules: supervisionTimeScheduleStoreModule,
    positions: positionsStoreModule,
    normPeriods: normPeriodStoreModule,
    infoCenter: infoCenterStoreModule,
    salaries: salaryStoreModule,
    employmentStatements: employmentStatementsStoreModule,
    departments: departmentsStoreModule,
    cypress: cypressStoreModule,
    absenceRequests: absenceRequestsStoreModule
  },
  state: {
    mainConfig: mainConfig
  },
  getters: {},
  mutations: {
    setConfig(state: IAuthRoot, mainConfig: IMainConfigImport): void {
      state.mainConfig.ENVIRONMENTNAME =
        window.location.href.indexOf("localhost") > -1 ? "Development" : mainConfig.environmentName;
      state.mainConfig.KEYCLOAK_CLIENTID = mainConfig.keyCloakClientId;
      state.mainConfig.KEYCLOAK_URL = mainConfig.keyCloakUrl;
      state.mainConfig.KEYCLOAK_REALM = mainConfig.keyCloakRealm;
      state.mainConfig.I18N_LOCALE = mainConfig.i18NLocale;
      state.mainConfig.I18N_FALLBACK_LOCALE = mainConfig.i18NFallbackLocale;
      state.mainConfig.urlToHelp = mainConfig.urlToHelp;
    }
  },
  actions: {
    async GetConfig({ commit }) {
      const response = await axios.get<any>("/api/environment.json");
      commit("setConfig", response.data.data as IMainConfigImport);
      return response.data.data;
    },
    async fetchInstitution({ commit }) {
      const response = await axios.get<any>("/api/environment.json");
      commit("setConfig", response.data.data as IMainConfigImport);
    },
    async reset() {
      Object.keys(this.state).forEach(async (key) => {
        const actionExists =
          Object.keys(this["_actions"]).findIndex((method) => method === key + "/reset") !== -1;
        if (actionExists) {
          await this.dispatch(key + "/reset");
        }
      });
    }
  },
  // strict: process.env.NODE_ENV == "development",
  strict: false,
  plugins: plugins.allPlugins
});

export function useStore() {
  return baseUseStore(key);
}
